module.exports = __webpack_public_path__ + "static/media/pariksha.2086f22f.jpg";